// Entry point for AoT compilation.
declare var System: any;

// Styles.
import './styles.scss';

import { platformBrowser } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { AppModuleNgFactory } from '../aot/angularApp/app/app.module.ngfactory';

enableProdMode();

platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);



// WEBPACK FOOTER //
// ./angularApp/main-aot.ts